export const ERROR_MESSAGES = {
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  500: "Internal Server Error",
} as const;

export const TOAST_CONFIG = {
  position: "top-right",
  autoClose: 4000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  theme: "light",
} as const;

export const LOGO_URL_MOBILE = "/pwa-192x192.png" as const;
export const LOGO_URL_DESKTOP = "/pwa-512x512.png" as const;

/** Product name shown as subtitle in app chrome when tenant company name is primary. */
export const APP_BRAND_NAME = "StarsPro" as const;

export const ITEMS_PER_PAGE = 10 as const;

/** Server-backed list pages: desktop datatable page-size selector options. */
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;

export type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number];

export const DB_NAME = "starsprodb" as const;
export const DB_VERSION = 1 as const;
